import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { trackedFunction } from 'reactiveweb/function';

export default class CurrentUserService extends Service {
  // Services
  @service permission;
  @service fetch;
  @service session;
  @service store;

  // Defaults
  @tracked model;

  // Getter and setter
  get id() {
    return this.model?.get('id');
  }

  get hasOneArtist() {
    return this.model?.hasMany('artists').ids().length === 1;
  }

  get artists() {
    return this.loadArtists.value || [];
  }

  get isAdmin() {
    return this.model?.get('isAdmin');
  }

  // Functions
  async ensureReady() {
    await this.loadArtists.promise;
  }

  async load(options = {}) {
    const response = await this.fetch.request('/userInfo', options);

    if (!response.user) {
      throw new Error('User not found');
    }
    const model = await this.store.push(
      this.store.normalize('user', response.user),
    );

    this.model = model;

    return model;
  }

  loadArtists = trackedFunction(this, async () => {
    return await this.model?.get('artists');
  });
}
